import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type ThemeMode = 'system' | 'light' | 'dark';

type SettingsState = {
  themeMode: ThemeMode;
  /** Pre-filled when creating a new group. */
  defaultCurrency: string;
  /** Show deactivated members in balance lists and pickers. */
  showInactiveMembers: boolean;
  /** Rows per page in the expenses table. */
  pageSize: number;
  setThemeMode: (mode: ThemeMode) => void;
  setDefaultCurrency: (currency: string) => void;
  setShowInactiveMembers: (value: boolean) => void;
  setPageSize: (value: number) => void;
};

/**
 * Persisted to `localStorage` under `gem.settings`. The inline script in
 * index.html reads the same key to apply the theme class before first paint —
 * keep the shape in step with it.
 */
export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      themeMode: 'system',
      defaultCurrency: 'USD',
      showInactiveMembers: false,
      pageSize: 25,
      setThemeMode: (themeMode) => set({ themeMode }),
      setDefaultCurrency: (defaultCurrency) => set({ defaultCurrency }),
      setShowInactiveMembers: (showInactiveMembers) => set({ showInactiveMembers }),
      setPageSize: (pageSize) => set({ pageSize }),
    }),
    {
      name: 'gem.settings',
      partialize: ({ themeMode, defaultCurrency, showInactiveMembers, pageSize }) => ({
        themeMode,
        defaultCurrency,
        showInactiveMembers,
        pageSize,
      }),
    }
  )
);
